import { Period } from './period';
import { PeriodStatus } from './period-status';

export function getLabelClassForPeriod(period: Period): string {
  if (!period) {
    return 'label-default';
  }
  switch (period.status(new Date())) {
    case PeriodStatus.CURRENT:
      return 'label-success';
    case PeriodStatus.FUTURE:
      return 'label-warning';
    case PeriodStatus.PAST:
      return 'label-danger';
    default:
      return 'label-default';
  }
}
